import takeRight from 'lodash-es/takeRight';

export const getTopLevelDomain = (url: string): string | null => {
  try {
    const matches = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    const domain = matches && matches[2];
    if (!domain) return null;
    const splitDomain = domain && domain.split('.');
    const topLevel = takeRight(splitDomain, 2);
    return topLevel.join('.');
  } catch (error) {
    return null;
  }
};
